import React from 'react';


const AboutUs = () => {
    return (
        <div className='container'>
          <div className='row mt-5 hero-row-reverse-mobile home-row jumbotron'>
            <div className='col-lg-6 text-center txt-md-left'>
              <div className='row mb-3'>
                <h1 className='display-4 font-weight-bold'>
                  Microsoft and SparkDev
                </h1>
              </div>
              <p className='lead'>
                Dream in Green teamed up with SparkDev and Microsoft to build this
                easy to use application so that kids from all over the world can
                learn about their impact on the environment and how to create a
                better world.
              </p>
            </div>
          </div>
        </div>
    );
};

export default AboutUs;